// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const CASE_URL = process.env.REACT_APP_CASE_URL;

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const REACT_APP_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const REACT_APP_STRIPE_PRICING_TABLE_ID = process.env.REACT_APP_STRIPE_PRICING_TABLE_ID;
export const REACT_APP_STRIPE_PRICNING_TABLE_ID_SIMPLE_T_WITH_LLM =
  process.env.REACT_APP_STRIPE_PRICNING_TABLE_ID_SIMPLE_T_WITH_LLM;
export const REACT_APP_STRIPE_PRICNING_TABLE_ID_SIMPLE_T_WITHOUT_LLM =
  process.env.REACT_APP_STRIPE_PRICNING_TABLE_ID_SIMPLE_T_WITHOUT_LLM;
export const REACT_APP_N8N_CHAT_AGENT_PUBLIC_KEY = process.env.REACT_APP_N8N_CHAT_AGENT_PUBLIC_KEY;
export const REACT_APP_N8N_CHAT_AGENT_CRED_NAME = process.env.REACT_APP_N8N_CHAT_AGENT_CRED_NAME;
export const REACT_APP_N8N_CHAT_AGENT_CRED_PASSWORD =
  process.env.REACT_APP_N8N_CHAT_AGENT_CRED_PASSWORD;
export const REACT_APP_CHAT_RECAPTCHA_SITE_KEY = process.env.REACT_APP_CHAT_RECAPTCHA_SITE_KEY;

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const SIMPLET_MANAGE_PACKAGE_ID = '04tJ6000000UB8JIAW';

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.productLibrary; // as '/dashboard'
